export const text = {
  COMMON_ERROR: 'Произошла ошибка',
  AUTH_ERROR: 'Неверный логин или пароль',
  RESET_PASSWORD_ERROR: 'Неверный e-mail',
};
